module.exports = __webpack_public_path__ + "img/time.e91e8bb5.svg";